export default __webpack_public_path__ + "static/Lexend-Bold-9d6fcbbc2f167aa14b5a44bfbfc0832d.woff";